 
  <div class="container">
    <div class="custom-tab-group card p-10">
      <div class="tab-button" 
           [class.active]="selectedTypeTabName === 'createcalendar'" 
           (click)="selectTab('createcalendar')">
        <span class="material-icons">bar_chart</span>
       KPI Gaps
      </div>
      <div class="tab-button" 
           [class.active]="selectedTypeTabName === 'employeeapproval'" 
           (click)="selectTab('employeeapproval')">
        <span class="material-icons">track_changes</span>
       Competency Gaps
      </div>
    </div>
    
    
    
    <div class="card  createcalendar">

      <!-- ============================================ KPI Gaps================================================== -->
       
      <div class="p-10 m-20 createcalendar"  *ngIf="selectedTypeTabName=='createcalendar'">   
        <div class="cardBox mb-20">
          <ion-row class="ion-align-items-center ion-justify-content-start ml-20  pt-20">
            <!-- Year Dropdown -->
            <ion-col size="12" size-sm="3"> 
              <mat-form-field  class="custom-mat-field mat-height40 mat-input-style w-100">
                <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                            (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                  <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                    {{ sharedService.transformYearToFyFormat(item.year) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
          
          
            <!-- Band Dropdown -->
            <ion-col size="12" size-sm="3" >
              <ng-multiselect-dropdown class="mat-height40 mat-input-style w-100"
                [placeholder]="'Select Band'"
                [settings]="dropdownSettingsForKPI"
                [data]="getKpiBandList"
                (onSelect)="onKpiBandSelect()"
                (onDeSelect)="onKpiBandDeSelect()"
                (onSelectAll)="onKpiBandAllSelect()"
                (onDeSelectAll)="onKpiBandAllDeSelect()">
              </ng-multiselect-dropdown>
            </ion-col>
          </ion-row>

          <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

          <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
            <ion-col size="12" size-lg="9">
              <ion-row class="ion-align-items-center">
                <!-- Search -->
                <ion-col size="12" size-sm="4" >
                  <mat-form-field class="mat-height40 mat-input-style w-100">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-col>
          
            <ion-col size="12" size-lg="3" >
              <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
                <label>
                  <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                  <mat-form-field class="w70px mat-height40 mat-input-style">
                    <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                      <mat-option [value]="2">2</mat-option>
                      <mat-option [value]="25">25</mat-option>
                      <mat-option [value]="50">50</mat-option>
                      <mat-option [value]="75">75</mat-option>
                      <mat-option [value]="100">100</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                </label>
                <!-- Download Icon -->
                <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
              </div>
            </ion-col>
          
          </ion-row>
          
          
          <div class="p-10">
            <ion-row>
              
                <div class="table-container">
                  <table class="custom-table rounded-header justify-content-center">
                     <thead>
                      <tr>                      
                       <th *ngFor="let item of tableHeaderForKpi"
                          class="fs-14 font_bold cl-black">
                          <div class=" verticle-center justify-content-space-between icon-style">
                            {{ item?.label }}
                          </div>
                         </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white">    
                      <tr> <td>Band 1</td> <td (click)="addProgramForm()" class="kpi">KPI 1</td> </tr>
                      <tr> <td>Band 2</td> <td (click)="addProgramForm()" class="kpi">KPI 2</td> </tr>
                      <tr> <td>Band 3</td> <td (click)="addProgramForm()" class="kpi">KPI 3</td> </tr>
                      <tr> <td>Band 4</td> <td (click)="addProgramForm()" class="kpi">KPI 4</td> </tr>
                      <tr> <td>Band 5</td> <td (click)="addProgramForm()" class="kpi">KPI 5</td> </tr>
                      <tr> <td>Band 6</td> <td (click)="addProgramForm()" class="kpi">KPI 6</td> </tr>
                      <tr> <td>Band 7</td> <td (click)="addProgramForm()" class="kpi">KPI 7</td> </tr>
                      <tr> <td>Band 8</td> <td (click)="addProgramForm()" class="kpi">KPI 8</td> </tr>
                      <tr> <td>Band 9</td> <td (click)="addProgramForm()" class="kpi">KPI 9</td> </tr>
                      <tr> <td>Band 10</td> <td (click)="addProgramForm()" class="kpi">KPI 10</td> </tr>
                    </tbody>
                    
                  </table>
                </div>                             
            
            </ion-row>
          </div>
        </div>     
      </div>





      <!-- ====================================== Competency Gaps ====================================================================-->


           
      <div class="p-10 m-20 createcalendar"  *ngIf="selectedTypeTabName=='employeeapproval'">   
        <div class="cardBox mb-20">
          <ion-row class="ion-align-items-center ion-justify-content-start ml-20  pt-20">
            <!-- Year Dropdown -->
            <ion-col size="12" size-sm="3">
              <mat-form-field  class="custom-mat-field mat-height40 mat-input-style w-100">
                <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                            (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                  <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                    {{ sharedService.transformYearToFyFormat(item.year) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
                     
            <!-- Band Dropdown -->
            <ion-col size="12" size-sm="3">
              <ng-multiselect-dropdown class="mat-height40 mat-input-style w-100"
                [placeholder]="'Select Band'"
                [settings]="dropdownSettingsForCompetency"
                [data]="getCompetencyBandList"
                (onSelect)="onCompetencyBandSelect()"
                (onDeSelect)="onCompetencyBandDeSelect()"
                (onSelectAll)="onCompetencyBandAllSelect()"
                (onDeSelectAll)="onCompetencyBandAllDeSelect()">
              </ng-multiselect-dropdown>
            </ion-col>
          </ion-row>


          <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

          <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
            <ion-col size="12" size-lg="9">
              <ion-row class="ion-align-items-center">
                <!-- Search -->
                <ion-col size="12" size-sm="4" >
                  <mat-form-field class="mat-height40 mat-input-style w-100">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-col>
          
            <ion-col size="12" size-lg="3" >
              <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
                <label>
                  <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                  <mat-form-field class="w70px mat-height40 mat-input-style">
                    <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                      <mat-option [value]="2">2</mat-option>
                      <mat-option [value]="25">25</mat-option>
                      <mat-option [value]="50">50</mat-option>
                      <mat-option [value]="75">75</mat-option>
                      <mat-option [value]="100">100</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                </label>
                <!-- Download Icon -->
                <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
              </div>
            </ion-col>
          
          </ion-row>
          
          
          <div class="p-10">
            <ion-row>
           
                <div class="table-container">
                  <table class="custom-table rounded-header justify-content-center"  >
                     <thead>
                      <tr>                      
                       <th *ngFor="let item of tableHeaderForCompetency"
                          class="fs-14 font_bold cl-black">
                          <div class=" verticle-center justify-content-space-between icon-style">
                            {{ item?.label }}
                          </div>
                         </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white"> 
                      <tr> <td>Strategic</td> <td (click)="addProgramForm()" class="kpi">Innovation and change
                      </td> </tr>
                      <tr> <td>Strategic</td> <td (click)="addProgramForm()" class="kpi">Applying Business Acumen </td> </tr>   
                      <tr> <td>Strategic</td> <td (click)="addProgramForm()" class="kpi">Analysis and Decision Making</td> </tr>
                     
                     
                    </tbody>
                    
                  </table>
                </div>                             
          
            </ion-row>
          </div>
        </div>     
      </div>

    </div>
 



    </div>

 
 